// import type { AxiosInstance } from "axios/index";
import { UserWorkspaceStatus } from "@pl-flight-recorder/web/interfaces/UserWorkspaceStatus";
import axios from "axios";
// import AxiosService from "./axios.service";

export interface Workspace {
  id: number;
  name: string;
  description: string;
  isPrivate: boolean;
  isSearchable: boolean;
  status: string;
  userworkspacemap: Array<{
    status: string;
    role?: {
      name: string;
    };
    user: {
      id: number;
      name: string;
      email: string;
    };
  }>;
}

interface UserResponse {
  id: number;
  userId: string;
  orgId: string;
  email: string;
  name: string;
  picture: string;
  defaultWorkspace?: {
    id: number;
    name: string;
    userWorkspaceStatus: UserWorkspaceStatus;
    role: { name: string };
  };
  organization?: {
    id: string;
  };
  organisation?: {
    id: string;
  };
  dp_color?: string;
}

class AuthService {
  private static instance: AuthService;
  private baseUrl = `${process.env.REACT_APP_API_BASE_URL}/uumm1`; // Needs /uumm1
  private axiosInstance;

  private constructor() {
    this.axiosInstance = axios.create({
      baseURL: this.baseUrl,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  public static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  async getWorkspaces(orgId: string, token: string): Promise<Workspace[]> {
    console.log("getWorkspaces", orgId, token);
    const response = await this.axiosInstance.get<Workspace[]>(
      `/workspace/org/${orgId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  }

  async switchWorkspace(
    workspaceId: number,
    token: string,
  ): Promise<Workspace[]> {
    const response = await this.axiosInstance.put<Workspace[]>(
      `/workspace/switchWorkspace/${workspaceId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  }

  async getUserFromToken(token: string): Promise<UserResponse> {
    const response = await this.axiosInstance.post<UserResponse>(
      "/user/loginregister/RESEARCHER",
      {}, // empty body
      {
        headers: {
          // userId: userId,
          Authorization: `Bearer ${token}`,
        },
      },
    );
    // rename organisation to organization in response
    response.data.organization = response.data.organisation;
    delete response.data.organisation;
    return response.data;
  }
}

export default AuthService;
